import { render, staticRenderFns } from "./StorageTierUpgradeBanner.vue?vue&type=template&id=108aa262&scoped=true&"
import script from "./StorageTierUpgradeBanner.vue?vue&type=script&lang=js&"
export * from "./StorageTierUpgradeBanner.vue?vue&type=script&lang=js&"
import style0 from "./StorageTierUpgradeBanner.vue?vue&type=style&index=0&id=108aa262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108aa262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108aa262')) {
      api.createRecord('108aa262', component.options)
    } else {
      api.reload('108aa262', component.options)
    }
    module.hot.accept("./StorageTierUpgradeBanner.vue?vue&type=template&id=108aa262&scoped=true&", function () {
      api.rerender('108aa262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/StorageTierUpgradeBanner.vue"
export default component.exports